import { Injectable } from '@angular/core';
import { DeviceDetectorService, BROWSERS, OS } from 'ngx-device-detector';
import { ScrollHelper } from './scroll-helper';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private cameraNotSupportedEnvironments: DeviceEnvironment[] = [
    { os: OS.IOS, browser: BROWSERS.CHROME },
    { os: OS.ANDROID, browser: BROWSERS.FIREFOX }
  ]

  get isMobileDevice(): boolean {
    return this.deviceService.isMobile() || this.deviceService.isTablet();
  }

  // checks if current device environment supports camera
  get isCameraSupported(): boolean {
    return this.isMobileDevice && !this.isOneOfEnvironments(this.cameraNotSupportedEnvironments);
  }

  get isSafari(): boolean {
    return this.deviceService.browser === BROWSERS.SAFARI;
  }

  get applePayAvailable(): boolean {
    if (this.deviceService.isDesktop()) {
      return this.deviceService.os === OS.MAC && this.deviceService.browser === BROWSERS.SAFARI;
    } else { // mobile device
      return this.deviceService.os === OS.IOS;
    }
  }

  constructor(private deviceService: DeviceDetectorService) {
      this.initScrollHelper();
  }

  // checks if current device environment is one of the environments passed as an argument
  private isOneOfEnvironments(environments: DeviceEnvironment[]): boolean {
    return environments
      .map(env => env.os === this.deviceService.os && env.browser === this.deviceService.browser)
      .includes(true);
  }

  private initScrollHelper(): void {
    ScrollHelper.scrollTopTimeout = this.deviceService.browser === BROWSERS.SAFARI ? 200 : 0;
    ScrollHelper.offersDialogOpenTimeout = this.deviceService.browser === BROWSERS.SAFARI ? 250 : 0;
  }
}

interface DeviceEnvironment {
  browser: string;
  os: string;
}
